export const isQuoteDirectDrive = quote => quote?.serviceType?.code === 'DR';
